<template>

	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('充电站:')" :label-width="60">
				<Select filterable :placeholder="$tt('站点列表')" style="width: 180px;" v-model="formInline.StationId">
					<Option :value=0>{{$tt('全部')}}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OrderNo" :placeholder="$tt('订单单号')">
				<span slot="prepend">{{$tt('订单单号')}}</span>
				</Input>
			</FormItem>
			<!-- <FormItem :label="$tt('开始时间')" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem :label="$tt('结束时间')" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem :label="$tt('选择时间')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem :label="$tt('支付方式')" :label-width="70" prop="trackName">
				<Select :placeholder="$tt('支付方式')" style="width: 100px;" v-model="formInline.PaymentWay">
					<Option :value='0'>{{$tt('全部')}}</Option>
					<Option :value='1'>{{$tt('即时支付')}}</Option>
					<Option :value='2'>{{$tt('钱包支付')}}</Option>
				</Select>
			</FormItem>
			<!-- <FormItem >
				<Input type="text" v-model="formInline.MemberName" :placeholder="$tt('会员名称')">
				<span slot="prepend">{{$tt('会员名称')}}</span>
				</Input>
			</FormItem> -->
			<FormItem>
				<Input type="text" style="width: 160px;" v-model="formInline.PhoneNo" :placeholder="$tt('会员手机')">
				<span slot="prepend">{{$tt('会员手机')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 160px;" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')">
				<span slot="prepend">{{$tt('设备编号')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" v-model="formInline.CouponName" :placeholder="$tt('优惠活动')">
				<span slot="prepend">{{$tt('优惠活动名称')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">{{$tt('导出文件')}}</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getChargeOrderUrl" @listData='getDeviceData'></MyPage>
		<echartModal ref="echartModal" curvesName="ChargeOrder"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	import expandRow from './ChargingOrderTemplate/ChargingOrderExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getChargeOrderUrl: webapi.base_api_url + '/Order/GetChargeOrder',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: this.$tt('设备信息添加'),
					type: "addDevice"
				},
				BreadcrumbList: [this.$tt('订单记录'), '>>', this.$tt('充电订单')],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: '',
					CouponName: '',
					PhoneNo: '',
					PaymentWay: 0,
				},
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					}, {
						title: this.$tt('订单单号'),
						key: 'OrderNo',
						width: 180
					}, {
						title: this.$tt('订单时间'),
						key: 'OrderTime',
						width: 110
					},
					{
						title: this.$tt('订单来源'),
						key: 'TradeType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: this.$tt('支付方式'),
						key: 'PaymentWay',
						minWidth: 100,
						render: (h, params) => {
							return h('div', this.$tEnum('PaymentWay', params.row.PaymentWay, params.row.PaymentWayDesc));
						}
					},
					{
						title: this.$tt('订单状态'),
						key: 'OrderStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					// {
					// 	title: '结算类型',
					// 	key: 'SettleTypeDesc',
					// 	minWidth: 100,
					// 	render: (h, params) => {
					// 		return h('div', this.$tEnum('SettleType', params.row.SettleType, params.row.SettleTypeDesc));
					// 	}
					// },
					{
						title: this.$tt('会员手机号码'),
						key: 'MemberPhone',
						minWidth: 120,
					},
					{
						title: this.$tt('会员名称'),
						key: 'MemberName',
						minWidth: 100,
					},
					{
						title: this.$tt('预付金额(元)'),
						key: 'OrderAmount',
						minWidth: 100,
					},
					{
						title: this.$tt('充电总费用(元)'),
						key: 'ChargeCost',
						minWidth: 100,
					},
					{
						title: this.$tt('优惠金额(元)'),
						key: 'CouponAmount',
						minWidth: 100,
					},
					{
						title: this.$tt('结算金额(元)'),
						key: 'CouponCost',
						minWidth: 100,
					},
					{
						title: this.$tt('优惠活动'),
						key: 'CouponName',
						minWidth: 100,
					},
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName',
						minWidth: 100,
					}, {
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						minWidth: 100,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('chargeCurves') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row.OrderNo)
										}
									}
								}, this.$tt('充电曲线')) : h(),
							]);
						}
					}
				],
				//导出专用
				columns2: [{
						title: this.$tt('订单单号'),
						key: 'OrderNo',
						width: 180
					}, {
						title: this.$tt('订单时间'),
						key: 'OrderTime',
						width: 110
					},
					{
						title: this.$tt('订单来源'),
						//key: 'TradeType',
						key: 'TradeTypeDesc',
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: this.$tt('支付方式'),
						key: 'PaymentWayDesc',
						minWidth: 100,
						render: (h, params) => {
							return h('div', this.$tEnum('PaymentWay', params.row.PaymentWay, params.row.PaymentWayDesc));
						}
					},
					{
						title: this.$tt('订单状态'),
						//key: 'OrderStatus',
						key: 'OrderStatusDesc',
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: this.$tt('结算类型'),
						//key: 'OrderStatus',
						key: 'SettleTypeDesc',
						render: (h, params) => {
							return h('div', this.$tEnum('SettleType', params.row.SettleType, params.row.SettleTypeDesc));
						}
					},
					{
						title: this.$tt('结算时间'),
						//key: 'OrderStatus',
						key: 'SettleTime',
						render: (h, params) => {
							return h('div', params.row.SettleTime);
						}
					},
					{
						title: this.$tt('会员手机号码'),
						key: 'MemberPhone'
					},
					{
						title: this.$tt('会员名称'),
						key: 'MemberName'
					},
					{
						title: this.$tt('预付金额(元)'),
						key: 'OrderAmount' //订单金额
					},
					{
						title: this.$tt('充电总费用(元)'), //
						key: 'ChargeCost'
					},
					{
						title: this.$tt('优惠金额(元)'),
						key: 'CouponAmount'
					},
					{
						title: this.$tt('结算金额(元)'),
						key: 'CouponCost'
					},
					{
						title: this.$tt('优惠活动'),
						key: 'CouponName'
					},
					{
						title: this.$tt('枪编号'),
						key: 'ConnectorNo'
					},
					{
						title: this.$tt('站点名称'),
						key: 'StationName'
					},
					{
						title: this.$tt('开始时间'),
						key: 'StartTime'
					},
					{
						title: this.$tt('结束时间'),
						key: 'EndTime'
					},
					{
						title: this.$tt('充电电费(元)'),
						key: 'ElecCost'
					},
					{
						title: this.$tt('充电服务费(元)'),
						key: 'ServiceCost'
					},
					{
						title: this.$tt('充电电量(度)'),
						key: 'ChargeKwh'
					},
					{
						title: this.$tt('起始SOC(%)'),
						key: 'BeginSoc'
					},
					{
						title: this.$tt('结束SOC(%)'),
						key: 'EndSoc'
					},
					{
						title: this.$tt('充电时长'),
						key: 'ChargeDurationDesc'
					},
					{
						title: this.$tt('退款金额(元)'),
						key: 'RefundAmount'
					},
					{
						title: this.$tt('退款状态'),
						key: 'RefundStatusDesc'
					},
					{
						title: this.$tt('退款时间'),
						key: 'RefundTime'
					},
					{
						title: this.$tt('停止原因'),
						key: 'TerminateReason'
					},
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					EquipmentNo: _this.formInline.EquipmentNo,
					MemberName: _this.formInline.MemberName,
					PhoneNo: _this.formInline.PhoneNo,
					CouponName: _this.formInline.CouponName,
					PaymentWay: _this.formInline.PaymentWay,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '充电订单',
					columns: this.columns2,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			//操作
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>

